/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Partner_Admin_Reset_Access_DescriptionInputs */



/**
* | output |
* | --- |
* | "This clears {email}'s passkey and signs them out. They'll need the new invite link to set up access again." |
*
* @param {Partner_Admin_Reset_Access_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_reset_access_description = /** @type {((inputs: Partner_Admin_Reset_Access_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Reset_Access_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Dies löscht den Passkey von ${i?.email} und meldet die Person ab. Sie benötigt den neuen Einladungslink, um den Zugang erneut einzurichten.`)
	return /** @type {LocalizedString} */ (`This clears ${i?.email}'s passkey and signs them out. They'll need the new invite link to set up access again.`)
});